<button
  id="holdButton"
  *ngIf="!record?.availability?.availableCopies && !isMoreOption"
  class="accent transparent"
  mat-flat-button
  [class.waiting]="waiting"
  appStopPropagation
  (click)="hold()">
  <ng-container *ngIf="!waiting"> {{ 'button.hold' | translate }} </ng-container>
  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
<button
  mat-menu-item
  *ngIf="!record?.availability?.availableCopies && isMoreOption"
  appStopPropagation
  [class.waiting]="waiting"
  (click)="hold()">
  <ng-container *ngIf="!waiting">
    <span class="odilo-icon" aria-hidden="true">{{ recordIcon }}</span>
    {{ 'button.hold' | translate }}
  </ng-container>
</button>
